var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.7,
    height: 27.298,
    viewBox: "0 0 23.7 27.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3532",
    "data-name": "Group 3532",
    transform: "translate(0.529 -0.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3531",
    "data-name": "Group 3531"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_523",
    "data-name": "Line 523",
    y1: 24.298,
    transform: "translate(11.319 1.592)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2954",
    "data-name": "Path 2954",
    d: "M.25,9.981,9.982.25l9.725,9.725",
    transform: "translate(1.342 1.342)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitLight);
export default __webpack_public_path__ + "static/media/Submit-Light.c0a7df9e10bce10d14bec3e32f2bc46c.svg";
export { ForwardRef as ReactComponent };